import {Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../src/environments/environment'
import { ShareWrapper } from './share-wrapper.component';
import { EntityRequest } from 'globals/store/programs.data';
import { ShareRequestComponent } from './share.request';
import { PublicStagingRequestData } from 'globals/store/share.data';
import { BrandingData } from 'globals/store/publish.data';
import { BrandingWrapperComponent } from 'src/app/components/branding/branding-wrapper.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'share-staging-request',
    template: `
<branding-wrapper 
  [brandingData]="brandingData" 
  [style.--sitebackground]="brandingData?.template?.sitebackground || '#ffffff'">
  <share-request
    #shareRequest
    [eventTitle]="data?.eventTitle || ''"
    [addeeTitle]="data?.sessionTitle || ''"
    [adderName]="data?.performerName || ''"
    [request]="data ? data.stagingRequest : { by: '', type: 'anyone', requestText: ''}"
    [type]="'staging'"
    [loading]="loading"
    [processing]="processing"
    [submitted]="submitted"
    (submit)="submit($event)"
  ></share-request>
</branding-wrapper>
    `,
    styleUrls: ['./share.editPerformer.scss'],
    standalone: true,
    imports: [BrandingWrapperComponent, ShareRequestComponent, CommonModule]
})
export class ShareStagingRequestComponent extends ShareWrapper<ShareStagingRequestComponent> {

    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
    id:string;
    loading:boolean;
    processing:boolean;
    disabled = true;
    submitted:boolean;
    @ViewChild('shareRequest') shareRequest: ShareRequestComponent
    data: PublicStagingRequestData
    brandingData: BrandingData

    constructor(private route:ActivatedRoute) {
      super()
      this.loading = true;
      document.title = "loading";
      this.route.params.subscribe(params=>{
        if(!params || !params.hasOwnProperty('id')) {
          this.loading = false;
          document.title = "Unavailable";
        } else {
          this.id = params.id;
          const url = `${this.api}/load-staging-request`
          this.take1(this.http.post(url, { id:this.id })).then((data: PublicStagingRequestData) => {
            this.loading = false
            document.title = "Staging Request " + (data?.eventTitle ? ' | ' + data.eventTitle : '');
            this.data = data
            this.brandingData = data.brandingData
          }, error => {
            this.loading = false;
            document.title = "Unavailable";
          })
        }
      })
    }

    submit(request: EntityRequest) {
      this.processing = true;
      

      request.by = this.data.performerName || this.shareRequest.submitterForAnyone.name || 'anonymous'
      request.type = this.data.performerName ? 'performer' : 'anyone'

      const time = new Date().getTime()
      if (!request.created) request.created = time
      request.modified = time

      const url = `${this.api}/submit-staging-request`
      this.take1(this.http.post(url, {
        id:this.id,
        request
      })).then((data:any) => {
        this.processing = false;
        this.submitted = true;
        if (data.error) {
          this.shareRequest.resultMessage = "File links can't be submitted at this time.\n\nPlease reload this page and try again."
        }
      }, error => {
        console.error({ error })
        this.processing = false;
        this.shareRequest.showError(this.shareRequest.cannotSubmitMessage)
      });
    }
}

